// Add any authorized administrator emails to this list
const ADMIN_EMAILS = [
  "austtint@gmail.com"
];

export const isOwner = (email) => {
  if (!email) return false;
  // .toLowerCase() prevents case-sensitivity bugs if they type AustinT@gmail.com
  return ADMIN_EMAILS.includes(email.toLowerCase()); 
};